import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Spinner,
  DropdownItem,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import * as _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  BackButton,
  CancelButton,
  GeneralErrors,
  PageHeader,
  KebabDropdown,
} from '../../components';
import { updateReport } from '../../redux/reports/actions';
import { useReadOnly, useConfirmAction } from '../../utils/hooks';

import layout from '../../styles/layout.module.scss';

export default function NotesForm ({ currReport }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const readOnly = useReadOnly();
  const {
    register,
    handleSubmit,
    formState,
  } = useForm({ defaultValues: currReport });

  const { isSubmitted } = formState;

  const pending = useSelector((s) => s.reports.changeReportPending);
  const error = useSelector((s) => s.reports.changeReportError);
  const submitSuccess = isSubmitted && !pending && !error;
  const confirmAction = useConfirmAction();

  const submit = useCallback((data) => {
    dispatch(updateReport({
      ...data,
      id: currReport.id,
    }));
  }, [currReport]);

  const removeNotes = useCallback(() => {
    confirmAction({
      action: 'delete',
      subjectType: 'notes',
      subject: 'your notes',
      onConfirm: () => dispatch(updateReport({
        notes: '',
        id: currReport.id,
      })),
      pendingPath: 'reports.changeReportPending',
      errorPath: 'reports.changeReportError',
      onSuccess: history.goBack,

    });
  }, [currReport, confirmAction]);

  // Submit success
  useEffect(() => {
    if (submitSuccess) {
      history.goBack();
    }
  }, [submitSuccess]);

  return (
    <div className={layout.page}>
      <PageHeader
        title="Notes"
        coverMenu
      >
        <BackButton/>
        {
          (
            !readOnly &&
            _.get(currReport, 'notes')
          ) && (
            <KebabDropdown right>
              <DropdownItem onClick={removeNotes}>
                <FontAwesomeIcon icon="trash" />
                Delete Notes
              </DropdownItem>
            </KebabDropdown>
          )
        }
      </PageHeader>
      <div className={layout.pageContent}>
        <div className={layout.responsiveContainer}>
          {!currReport ?
            <div className="text-center">
              <Spinner />
            </div>
            :
            <Form onSubmit={handleSubmit(submit)}>
              <FormGroup>
                <Label>Notes</Label>
                <Input
                  id="textid"
                  innerRef={register}
                  type="textarea"
                  name="notes"
                  invalid={ isSubmitted && _.has(error, 'notes') }
                  disabled={readOnly}
                />
                <FormFeedback role="alert">
                  { _.get(error, 'notes') }
                </FormFeedback>
              </FormGroup>
              { isSubmitted && <GeneralErrors error={error} /> }
              {!readOnly && (
                <Button
                  color="primary"
                  disabled={pending}
                  block
                >
                  Submit{' '}
                  { pending && <Spinner size="sm" /> }
                </Button>
              )}
              <CancelButton />
            </Form>
          }
        </div>
      </div>
    </div>
  );
}
